import React from 'react';
import { Box, BoxProps } from '@mantine/core';
import { useResponsiveLayout } from '../../hooks/useResponsiveLayout';
import { useViewportSize } from '../../hooks/useViewportSize';

interface MobileLayoutProps extends BoxProps {
  children: React.ReactNode;
  fullHeight?: boolean;
  safeArea?: boolean;
}

export const MobileLayout: React.FC<MobileLayoutProps> = ({
  children,
  fullHeight = true,
  safeArea = true,
  ...boxProps
}) => {
  const { isMobile } = useResponsiveLayout();
  const viewport = useViewportSize();
  
  const styles: React.CSSProperties = {
    minHeight: fullHeight ? '100vh' : undefined,
    paddingTop: safeArea && isMobile ? `${viewport.safeAreaTop}px` : undefined,
    paddingBottom: safeArea && isMobile ? `${viewport.safeAreaBottom}px` : undefined,
  };
  
  return (
    <Box
      style={styles}
      {...boxProps}
    >
      {children}
    </Box>
  );
};